/*
 *###############################################################################
 *Module Name                   : VoucherGRNContent.js                     #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Friday, October 12th 2021, 3:20:00 pm          #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

//Import react and bootstrap components
import React, { useState } from "react"
import {
  CardText,
  Col,
  Row,
  Alert,
  Button,
} from "reactstrap"
//Import Framework components
import DPTextBox from "framework/components/DPTextBox"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"
import DPTextBoxTow from "framework/components/DPTextBoxTow"

const VoucherGRNContent = ({
  Gen_DataSearch,
  AlertColor,
  AlertMsg,
  show,
  Gen_Code,
  Gen_Code_OnChange,
  Gen_Code_onBlur,
  Gen_Code_Enabled,
  Gen_Supplier,
  Gen_Supplier_OnChange,
  Gen_Supplier_Enabled,
  Gen_Location,
  Gen_Location_OnChange,
  Gen_Location_Enabled,
  Gen_TxnDate,
  Gen_TxnDate_OnChange,
  Gen_TxnDate_Enabled,
  Gen_Remark1,
  Gen_Remark1_OnChange,
  Gen_Remark1_Enabled,
  Gen_Remark2,
  Gen_Remark2_OnChange,
  Gen_Remark2_Enabled,

  SearchDefaultSorted,
  SearchModelOpen,
  SearchModelTrigger,
  SearchGetSelectRow,
  Gen_VoucherPOSearch,
  Gen_VoucherPO,
  Gen_VoucherPO_OnChange,
  Gen_VoucherPO_onBlur,

  SearchDefaultSortedMain,
  SearchModelOpenMain,
  SearchModelTriggerMain,
  SearchGetSelectRowMain,
  Gen_BatchNo,
  Gen_BatchNo_OnChange,
  Gen_BatchNo_Enabled,
  Gen_mainSearchEnabled,
  menuCode,
  LocationCode,
  supplierDesc,
  model_xlarge_sup,
  model_xlarge_loc,
  tox_xlarge_sup,
  tox_xlarge_loc,
  supplierOnblur,
  locationOnblur,
  locationDesc,
  GetSelectRowLoc,
  GetSelectRowSup,
  supSearchDisable,
  locSearchDisable,
  disableRefNo

}) => {


  const [mainSearchCol, setmainSearchCol] = useState([])
  const [poSearchCol, setpoSearchCol] = useState([])
  const [mainSearchColLoc, setmainSearchColLoc] = useState([])
  const [mainSearchColSup, setmainSearchColSup] = useState([])

  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')

  const ApiURL = window.Links.ApiURL

  React.useEffect(async () => {

    setmainSearchCol(await loadPopupSearchPay(menuCode, "VOUGRN"))
    setpoSearchCol(await loadPopupSearchPay(menuCode, "VOUGPO"))
    setmainSearchColLoc(await loadPopupSearchPay(menuCode, "LOCATION"))
    setmainSearchColSup(await loadPopupSearchPay(menuCode, "SUPPLIER"))
  }, [menuCode])


  return (
    <React.Fragment>
      <div>
        <Col sm="12">
          <CardText className="mb-0">
            <Row>
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                </Alert>
              ) : null}
              <Col sm={12} md={6} className="mb-4-sm">
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Document No"
                      textType="text"
                      maxLength="13"
                      value={Gen_Code}
                      onChange={Gen_Code_OnChange}
                      disabled={Gen_Code_Enabled}
                      onBlur={Gen_Code_onBlur}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={Gen_DataSearch}
                      color="success"
                      className="btn-sm"
                      disabled={Gen_mainSearchEnabled}
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {/* <DPDropDown
                      rowClass="mb-4-sm"
                      labelText="Supplier"
                      optionGroup={optionSupplier}
                      selectedGroup={Gen_Supplier}
                      onChange={Gen_Supplier_OnChange}
                      disabled={Gen_Supplier_Enabled}
                    /> */}
                    <DPTextBoxTow
                      labelText="Supplier"
                      disabled1={supSearchDisable ? true : Gen_Supplier_Enabled}
                      disabled2={true}
                      value1={Gen_Supplier}
                      value2={supplierDesc}
                      onChange1={Gen_Supplier_OnChange}
                      onBlur1={supplierOnblur}

                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={tox_xlarge_sup}
                      color="success"
                      className="btn-sm"
                      disabled={supSearchDisable}
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Remarks 1"
                      textType="text"
                      maxLength="50"
                      value={Gen_Remark1}
                      onChange={Gen_Remark1_OnChange}
                      disabled={Gen_Remark1_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Voucher PO No."
                      textType="text"
                      maxLength="50"
                      value={Gen_VoucherPO}
                      onChange={Gen_VoucherPO_OnChange}
                      disabled={disableRefNo}
                      onBlur={Gen_VoucherPO_onBlur}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={Gen_VoucherPOSearch}
                      color="success"
                      className="btn-sm"
                      disabled={disableRefNo}
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col sm={12} md={6} className="mb-4-sm">
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Date"
                      textType="date"
                      value={Gen_TxnDate}
                      onChange={Gen_TxnDate_OnChange}
                      disabled={Gen_TxnDate_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                </Row>
                <Row>
                  <Col>
                    {/* <DPDropDown
                      rowClass="mb-4-sm"
                      labelText="Location"
                      optionGroup={optionLocation}
                      selectedGroup={Gen_Location}
                      onChange={Gen_Location_OnChange}
                      disabled={Gen_Location_Enabled}
                    /> */}
                    <DPTextBoxTow
                      labelText="Location"
                      disabled1={locSearchDisable ? true : Gen_Location_Enabled}
                      disabled2={true}
                      value1={Gen_Location}
                      value2={locationDesc}
                      onChange1={Gen_Location_OnChange}
                      onBlur1={locationOnblur}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm">
                    <Button
                      onClick={tox_xlarge_loc}
                      color="success"
                      className="btn-sm"
                      disabled={locSearchDisable}
                    >
                      <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Remarks 2"
                      textType="text"
                      maxLength="50"
                      value={Gen_Remark2}
                      onChange={Gen_Remark2_OnChange}
                      disabled={Gen_Remark2_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                </Row>
                <Row>
                  <Col>
                    <DPTextBox
                      rowClass="mb-2-sm"
                      labelText="Batch No"
                      textType="text"
                      maxLength="15"
                      value={Gen_BatchNo}
                      onChange={Gen_BatchNo_OnChange}
                      disabled={Gen_BatchNo_Enabled}
                    />
                  </Col>
                  <Col sm={12} md={1} className="mb-4-sm"></Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col sm={12} md={6} className="mb-3-sm"></Col>
              <Col sm={12} md={6} className="mb-3-sm"></Col>
            </Row>
          </CardText>
        </Col>

        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={poSearchCol}
          defaultSorted={SearchDefaultSorted}
          mainTitle={"Voucher Purchase Order Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpen}
          toggle={SearchModelTrigger}
          getSelect={SearchGetSelectRow}
          APIURL={ApiURL}
          URLPath={"VOUGPO"}
          MenuCode={menuCode}
          KeyVal={'PO'}
          searchBy={'HED_RUNNO'}
          FilterStr={groupFilter}
        />

        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={mainSearchCol}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Voucher Good Received Note  Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={SearchModelOpenMain}
          toggle={SearchModelTriggerMain}
          getSelect={SearchGetSelectRowMain}
          APIURL={ApiURL}
          URLPath={"VOUGRN"}
          MenuCode={menuCode}
          KeyVal={'GRN'}
          searchBy={'HED_RUNNO'}
          FilterStr={`AND HED_LOC = ${LocationCode}`}
        />

        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={mainSearchColSup}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Supplier Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_sup}
          toggle={tox_xlarge_sup}
          getSelect={GetSelectRowSup}
          APIURL={ApiURL}
          URLPath={"SUPPLIER"}
          MenuCode={menuCode}
          KeyVal={'SUP'}
          searchBy={'SM_CODE'}
          FilterStr={groupFilter}
        />

        <DPSearchBoxDynamic
          searchData={Datatablesub}
          columns={mainSearchColLoc}
          defaultSorted={SearchDefaultSortedMain}
          mainTitle={"Location Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={model_xlarge_loc}
          toggle={tox_xlarge_loc}
          getSelect={GetSelectRowLoc}
          APIURL={ApiURL}
          URLPath={"LOCATION"}
          MenuCode={menuCode}
          KeyVal={'LOC'}
          searchBy={'LOC_CODE'}
          FilterStr={groupFilter}
        />


      </div>
    </React.Fragment>
  )
}
export default VoucherGRNContent
